/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MenuAudiencesIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6190B7',
  colorSecondary = '#C9DCEB',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2868 7.71429C30.4171 7.71429 32.144 5.98738 32.144 3.85714C32.144 1.7269 30.4171 0 28.2868 0C26.1566 0 24.4297 1.7269 24.4297 3.85714C24.4297 5.98738 26.1566 7.71429 28.2868 7.71429Z"
        fill={colorSecondary}
      />
      <path
        d="M34.715 10.2853V23.1424H32.1436V35.9996H24.4293V23.1424L23.1436 8.0578C23.522 7.83922 23.9608 7.71387 24.4293 7.71387H32.1436C33.5635 7.71387 34.715 8.86539 34.715 10.2853Z"
        fill={colorSecondary}
      />
      <path
        d="M18.0007 7.71429C20.1309 7.71429 21.8578 5.98738 21.8578 3.85714C21.8578 1.7269 20.1309 0 18.0007 0C15.8705 0 14.1436 1.7269 14.1436 3.85714C14.1436 5.98738 15.8705 7.71429 18.0007 7.71429Z"
        fill={color}
      />
      <path
        d="M23.1431 8.0578L21.8574 23.1424V35.9996H14.1431V23.1424L12.8574 8.0578C13.2359 7.83922 13.6747 7.71387 14.1431 7.71387H21.8574C22.3259 7.71387 22.7647 7.83922 23.1431 8.0578Z"
        fill={color}
      />
      <path
        d="M24.4289 10.2861V23.1432H21.8574V10.2861C21.8574 9.33467 22.3749 8.50297 23.1431 8.05859C23.9114 8.50297 24.4289 9.33475 24.4289 10.2861Z"
        fill={color}
      />
      <path
        d="M7.71457 7.71429C9.84481 7.71429 11.5717 5.98738 11.5717 3.85714C11.5717 1.7269 9.84481 0 7.71457 0C5.58432 0 3.85742 1.7269 3.85742 3.85714C3.85742 5.98738 5.58432 7.71429 7.71457 7.71429Z"
        fill={colorSecondary}
      />
      <path
        d="M12.8576 8.0578L11.5718 23.1424V35.9996H3.85756V23.1424H1.28613V10.2853C1.28613 8.86539 2.43765 7.71387 3.85756 7.71387H11.5718C12.0403 7.71387 12.4791 7.83922 12.8576 8.0578Z"
        fill={colorSecondary}
      />
      <path
        d="M14.1437 10.2851V23.1423H11.5723V10.2851C11.5723 9.33369 12.0898 8.50199 12.858 8.05762C13.6262 8.50199 14.1437 9.33377 14.1437 10.2851Z"
        fill={color}
      />
    </svg>
  );
};
